import React from 'react';
import { css } from 'emotion';
import { useT } from 'client/i18n/hooks/useT';
import { Button } from '../../../../shared/Button/NewButton';
import {
  Section,
  ContentWrapper,
  Heading,
  SubHeader,
  HeroImageContainer,
  HeroImagePictureWrapper1,
  HeroImagePictureWrapper2,
} from './styles';
import { RetinaPicture } from '../../../../components/RetinaPicture';
import { events } from '../../events';
import { WordPressHero } from '../../../../components/SignupPage/components/WordPressHero';

function HeroImage() {
  const t = useT();

  return (
    <HeroImageContainer>
      <HeroImagePictureWrapper1>
        <RetinaPicture
          imagePath="/wordpress/hero"
          alt={t(
            'WordpressScreen.Hero.HeroOne.AltText',
            'Smiling woman wearing headphones writing in a notebook',
            'Alt text for a hero image on the WordPress marking screen of a smiling woman wearing headphones writing in a notebook'
          )}
          fallbackExtension="jpg"
        />
      </HeroImagePictureWrapper1>
      <HeroImagePictureWrapper2>
        <RetinaPicture
          imagePath="/wordpress/convert-post-ui"
          alt={t(
            'WordpressScreen.Hero.HeroTwo.AltText',
            'Abstract user interface to convert an WordPress blog post into a podcast',
            'Alt text for a hero image on the WordPress marking screen of an abstract user interface to convert an WordPress blog post into a podcast'
          )}
          fallbackExtension="png"
        />
      </HeroImagePictureWrapper2>
    </HeroImageContainer>
  );
}

export function Hero() {
  const t = useT();

  return (
    <Section>
      <ContentWrapper>
        <WordPressHero fillColor="#FFFFFF" />
        <Heading>
          {t(
            'WordpressScreen.Hero.Header',
            'The easiest way to grow your audience with audio.',
            'The header for the Wordpress marketing screen hero component'
          )}
        </Heading>
        <Button
          color="onDark"
          className={css`
            width: 240px;
            margin: 48px 0 20px;
          `}
          kind="link"
          href="/signup?ref=wp"
          onClick={() => {
            events.clickWordPressSignUpCTA('hero');
          }}
        >
          {t(
            'WordpressScreen.Hero.StartAction',
            'Get started',
            'The action for the Wordpress marketing screen hero component to begin the process of bringing your WordPress blog to podcast format'
          )}
        </Button>
        <SubHeader>
          {t(
            'WordpressScreen.Hero.SubHeader',
            'If you’re already on Anchor, you’ll need to create a new account.',
            'The subheader for the Wordpress marketing screen hero component to let users know that if they are already an Anchor user, they will need a new account in order to link their WordPress account'
          )}
        </SubHeader>
        <HeroImage />
      </ContentWrapper>
    </Section>
  );
}
